import React from "react";
import { ProgramData } from "@interfaces/Interfaces";
import * as ProgramUtils from "@utils/programUtils";

type NQPCourseSelectionProps = {
  program: ProgramData;
  nqpCourse: string;
  onNQPCourseChange: (nqpCourse: string) => void;
};

const NQPCourseSelection: React.FC<NQPCourseSelectionProps> = (props) => {
  if (!ProgramUtils.showNQPCourseInDetailsPage(props.program, props.program.ID)) {
    return null;
  }

  return (
    <>
      <div className="text-acc-11px font-bold leading-acc-lh text-grey-70 mt-4 mb-1.5">{"Induction Course Number"}</div>
      <select
        className="w-full appearance-none bg-gray-200 border border-gray-300 rounded-md py-2 px-3 pr-10 text-grey-80 leading-tight focus:outline-none focus:border-blue-500 truncate custom-select-arrow cursor-pointer"
        value={props.nqpCourse}
        onChange={(event) => props.onNQPCourseChange(event.target.value)}
      >
        <option
          value=""
          disabled
        >
          {"Choose your course"}
        </option>
        {props.program.CourseIds?.map((course) => (
          <option
            key={course}
            value={course}
          >
            {course}
          </option>
        ))}
      </select>
    </>
  );
};

export default NQPCourseSelection;
